<template>
    <BaseView>
        <template v-slot:top>
            <TopNavigation />
            <SearchBar
                v-if="filtersLoaded && !initialLoading"
                @search="updateSearch"
                @filter="openFilterModal"
            />
            <inspection-count
                v-if="isOnFreePlan"
                :user="user"
            />
        </template>
        <div v-pull-to-refresh="refreshInspections">
            <template
                v-if="doneInspections && doneInspections.length > 0"
            >
                <Inspection
                    v-for="inspection in doneInspections"
                    :key="inspection.id"
                    :inspection="inspection"
                    @click.native="openDetailsModal(inspection)"
                />

                <div class="flex justify-center">
                    <div v-if="loading" class="p-4 flex-col text-80">
                        <loader />
                    </div>

                    <button
                        v-if="!loading && hasMore"
                        class="btn btn-default btn-primary main-button mb-4"
                        type="text"
                        @click="loadMore"
                    >
                        {{ $t("Load more") }}
                    </button>
                </div>
            </template>

            <div v-else class="middle-of-page">
                {{ $t("There are no done inspections.") }}
            </div>
        </div>

        <template v-slot:bottom>
            <bottom-navigation />
        </template>

        <portal to="modals">
            <transition name="fade">
                <InspectionDetailsModal
                    v-if="detailsModalOpen"
                    :inspection="selectedInspection"
                    @show="show"
                    @edit="edit"
                    @close="closeDetailsModal"
                />

                <FilterModal
                    v-if="filterModalOpen"
                    :filters="filters"
                    :user-filter-options="userFilterOptions"
                    :site-filter-options="siteFilterOptions"
                    @update="updateFilters"
                    @close="closeFilterModal"
                />
            </transition>
        </portal>
    </BaseView>
</template>

<script>
import { mapGetters } from 'vuex';
import Inspection from '@mobile/views/Checklists/Items/Inspection.vue';
import InspectionDetailsModal from '@mobile/views/Checklists/Modals/InspectionDetails.vue';
import FilterModal from '@mobile/views/Checklists/Modals/InspectionFilter.vue';
import TopNavigation from '@mobile/views/Checklists/components/Navigation';
import Loader from '@mobile/components/Loader.vue';
import InspectionCount from '@mobile/components/InspectionCount.vue';
import inspectionService from '@mobile/services/inspection';
import BaseView from '@mobile/components/BaseView.vue';
import SearchBar from '@mobile/components/SearchBar.vue';
import OnFreePlan from '@mobile/mixins/OnFreePlan';
import { eventBus } from '@/eventBus';

export default {
    name: 'ChecklistInspections',

    mixins: [
        OnFreePlan,
    ],

    components: {
        InspectionCount,
        Inspection,
        TopNavigation,
        Loader,
        FilterModal,
        InspectionDetailsModal,
        BaseView,
        SearchBar,
    },

    props: {},

    data: () => ({
        filterModalOpen: false,
        detailsModalOpen: false,
        selectedInspection: null,
        filters: {
            own: 0,
            user: null,
            from: null,
            to: null,
            site: null,
            search: null,
        },
        filtersLoaded: false,
        userFilterOptions: {},
        siteFilterOptions: {},
    }),

    computed: {
        ...mapGetters({
            doneInspections: 'inspections/done',
            hasMore: 'inspections/has_next_page',
            loading: 'inspections/loading',
            initialLoading: 'inspections/initial_loading',
        }),
    },

    created() {
        this.loadInspections();
    },

    methods: {
        loadInspections() {
            // todo promise all
            return Promise.all([
                inspectionService.getFilterOptions(),
                this.$store.dispatch('inspections/query', this.filters),
            ]).then(([filterOptions]) => {
                this.userFilterOptions = filterOptions.users;
                this.siteFilterOptions = filterOptions.sites;
                this.filtersLoaded = true;
                eventBus.$emit('loaded');
            }, (error) => {
                eventBus.$emit('client-error', error);
            })

        },
        refreshInspections() {
            this.$store.dispatch('inspections/query', {
                own: 0,
                user: null,
                from: null,
                to: null,
                site: null,
                search: null,
            }).catch((error) => {
                eventBus.$emit('client-error', error);
            });
        },

        openDetailsModal(inspection) {
            this.selectedInspection = inspection;
            this.detailsModalOpen = true;
        },

        closeDetailsModal() {
            this.detailsModalOpen = false;
            this.selectedChecklist = null;
        },

        openFilterModal() {
            this.filterModalOpen = true;
        },

        closeFilterModal() {
            this.filterModalOpen = false;
        },

        show() {
            this.$router.push({
                name: 'done-inspection',
                params: {
                    inspectionId: this.selectedInspection.inspection_id,
                },
            });
        },

        updateFilters(filters) {
            eventBus.$emit('loading');
            this.filters = { ...this.filters, ...filters };
            this.$store.dispatch('inspections/query', {
                filters: this.filters,
            }).then(() => {
                eventBus.$emit('loaded');
            }, (error) => {
                eventBus.$emit('client-error', error);
            });
        },

        updateSearch(value) {
            eventBus.$emit('loading');
            this.filters.search = value;
            this.$store.dispatch('inspections/query', {
                filters: this.filters,
            }).then(() => {
                eventBus.$emit('loaded');
            }, (error) => {
                eventBus.$emit('client-error', error);
            });
        },

        loadMore() {
            this.$store.dispatch('inspections/loadMore', {
                filters: this.filters,
            }).catch((error) => {
                eventBus.$emit('client-error', error);
            });
        },

        edit() {
            this.$router.push({
                name: 'conduct',
                params: {
                    resourceId: this.selectedInspection.inspection_id,
                    type: 'inspection',
                },
            });
        },
    },
};
</script>
